import { render, staticRenderFns } from "./shipping.vue?vue&type=template&id=10010ef5&scoped=true"
import script from "./shipping.vue?vue&type=script&lang=js"
export * from "./shipping.vue?vue&type=script&lang=js"
import style0 from "./shipping.vue?vue&type=style&index=0&id=10010ef5&prod&lang=scss&scoped=true"
import style1 from "./shipping.vue?vue&type=style&index=1&id=10010ef5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10010ef5",
  null
  
)

export default component.exports